import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/packing/show_process/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },
  fetchHarvestedBatch(organization_id, harvested_batch_id) {
    return RequesterV1.get(
      `organization/process/packing/manage_harvested_batch/${organization_id}/fetch_harvested_batch/${harvested_batch_id}`
    );
  },
  create(organization_id, harvest_process_id, harvested_batch_params) {
    return RequesterV1.post(
      `organization/process/packing/manage_harvested_batch/${organization_id}/create/${harvest_process_id}`,
      { harvested_batch: harvested_batch_params }
    );
  },
  update(organization_id, harvested_batch_id, harvest_process_id, harvested_batch_params) {
    return RequesterV1.post(
      `organization/process/packing/manage_harvested_batch/${organization_id}/update/${harvested_batch_id}/${harvest_process_id}`,
      { harvested_batch: harvested_batch_params }
    );
  },
  destroy(organization_id, harvested_batch_id) {
    return RequesterV1.delete(
      `organization/process/packing/manage_harvested_batch/${organization_id}/destroy/${harvested_batch_id}`
    );
  }
};
